/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHomeQuery } from "@/services";

export const useHome = ({ disabledShowId, savedFilter }: { disabledShowId?: boolean; savedFilter?: any }) => {
  const query = useHomeQuery({ enabled: !disabledShowId, savedFilter });

  return {
    home: query.data ?? {},
    loading: query.isFetching,
  };
};
